"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
const purple_1 = __importDefault(require("@material-ui/core/colors/purple"));
const green_1 = __importDefault(require("@material-ui/core/colors/green"));
const yellow_1 = __importDefault(require("@material-ui/core/colors/yellow"));
const red_1 = __importDefault(require("@material-ui/core/colors/red"));
const general_1 = __importDefault(require("./general"));
const overrides_1 = __importDefault(require("./overrides"));
const theme = styles_1.createMuiTheme(general_1.default, {
    palette: {
        primary: {
            ...purple_1.default,
            main: '#0d9ee3',
            light: '#48BDF5',
            dark: '#0A7BB1',
            100: '#E4EEFA',
        },
        secondary: {
            ...green_1.default,
            main: green_1.default[500],
            light: green_1.default[300],
            dark: green_1.default[700],
        },
        text: {
            primary: '#212529',
            secondary: 'rgba(33, 37, 41, 0.8)',
        },
        background: {
            paper: '#fff',
            default: '#fafafa',
        },
        results: {
            bad: {
                main: red_1.default[500],
                light: red_1.default[200],
                dark: red_1.default[800],
            },
            caution: {
                main: yellow_1.default[500],
                light: yellow_1.default[200],
                dark: yellow_1.default[800],
            },
            good: {
                main: green_1.default[500],
                light: green_1.default[200],
                dark: green_1.default[800],
            },
        },
    },
    typography: {
        button: {
            // fontStyle: "italic"
            fontWeight: 500,
            textTransform: 'none',
        },
    },
});
exports.default = styles_1.responsiveFontSizes(overrides_1.default(theme));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibXlmYXJvLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL215ZmFyby5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7OztBQUFBLHFEQUErRTtBQUMvRSw2RUFBcUQ7QUFDckQsMkVBQW1EO0FBQ25ELDZFQUFxRDtBQUNyRCx1RUFBK0M7QUFDL0Msd0RBQW9DO0FBQ3BDLDREQUFvQztBQUVwQyxNQUFNLEtBQUssR0FBRyx1QkFBYyxDQUFDLGlCQUFXLEVBQUU7SUFDeEMsT0FBTyxFQUFFO1FBQ1AsT0FBTyxFQUFFO1lBQ1AsR0FBRyxnQkFBTTtZQUNULElBQUksRUFBRSxTQUFTO1lBQ2YsS0FBSyxFQUFFLFNBQVM7WUFDaEIsSUFBSSxFQUFFLFNBQVM7WUFDZixHQUFHLEVBQUUsU0FBUztTQUNmO1FBQ0QsU0FBUyxFQUFFO1lBQ1QsR0FBRyxlQUFLO1lBQ1IsSUFBSSxFQUFFLGVBQUssQ0FBQyxHQUFHLENBQUM7WUFDaEIsS0FBSyxFQUFFLGVBQUssQ0FBQyxHQUFHLENBQUM7WUFDakIsSUFBSSxFQUFFLGVBQUssQ0FBQyxHQUFHLENBQUM7U0FDakI7UUFDRCxJQUFJLEVBQUU7WUFDSixPQUFPLEVBQUUsU0FBUztZQUNsQixTQUFTLEVBQUUsdUJBQXVCO1NBQ25DO1FBQ0QsVUFBVSxFQUFFO1lBQ1YsS0FBSyxFQUFFLE1BQU07WUFDYixPQUFPLEVBQUUsU0FBUztTQUNuQjtRQUNELE9BQU8sRUFBRTtZQUNQLEdBQUcsRUFBRTtnQkFDSCxJQUFJLEVBQUUsYUFBRyxDQUFDLEdBQUcsQ0FBQztnQkFDZCxLQUFLLEVBQUUsYUFBRyxDQUFDLEdBQUcsQ0FBQztnQkFDZixJQUFJLEVBQUUsYUFBRyxDQUFDLEdBQUcsQ0FBQzthQUNmO1lBQ0QsT0FBTyxFQUFFO2dCQUNQLElBQUksRUFBRSxnQkFBTSxDQUFDLEdBQUcsQ0FBQztnQkFDakIsS0FBSyxFQUFFLGdCQUFNLENBQUMsR0FBRyxDQUFDO2dCQUNsQixJQUFJLEVBQUUsZ0JBQU0sQ0FBQyxHQUFHLENBQUM7YUFDbEI7WUFDRCxJQUFJLEVBQUU7Z0JBQ0osSUFBSSxFQUFFLGVBQUssQ0FBQyxHQUFHLENBQUM7Z0JBQ2hCLEtBQUssRUFBRSxlQUFLLENBQUMsR0FBRyxDQUFDO2dCQUNqQixJQUFJLEVBQUUsZUFBSyxDQUFDLEdBQUcsQ0FBQzthQUNqQjtTQUNGO0tBQ0Y7SUFDRCxVQUFVLEVBQUU7UUFDVixNQUFNLEVBQUU7WUFDTixzQkFBc0I7WUFDdEIsVUFBVSxFQUFFLEdBQUc7WUFDZixhQUFhLEVBQUUsTUFBTTtTQUN0QjtLQUNGO0NBQ0YsQ0FBQyxDQUFDO0FBRUgsa0JBQWUsNEJBQW1CLENBQUMsbUJBQVMsQ0FBQyxLQUFLLENBQUMsQ0FBQyxDQUFDIn0=